import { formatDateTime, formatDateToString } from "../utils/dateFormat";
import type { ProductAdministrationDto } from "../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Odata/V1/models/index";
import type { ProductRow } from "../routes/products/route";

/**
 * Maps ProductAdministrationDto from the backend API to ProductRow for the frontend.
 *
 * Field mappings:
 * - productCode (number) -> productCode (string)
 * - productName -> productName
 * - productGroupCode (number) -> productGroupCode (string)
 * - productStartDate (Date) -> ingangsdatum (string formatted as YYYY-MM-DD)
 * - taxonomicNumber (number) -> gewascode (string)
 * - expired (boolean) -> vervallen (boolean)
 */
export function mapProductDtoToRow(dto: ProductAdministrationDto): ProductRow {
  return {
    productCode: dto.productCode?.toString() ?? "",
    productName: dto.productName ?? "",
    productGroupCode: dto.productGroupCode?.toString() ?? "",
    ingangsdatum: dto.productStartDate
      ? formatDateToString(dto.productStartDate)
      : "",
    gewascode: dto.taxonomicNumber?.toString() ?? "",
    hasprimarycharacteristic: dto.hasPrimaryCharacteristic ?? false,
    vervallen: dto.expired ?? false,
    vbnChangeDateTime: dto.vbnModifiedDate
      ? formatDateTime(dto.vbnModifiedDate)
      : "",
  };
}

/**
 * Maps an array of ProductAdministrationDto to ProductRow array.
 */
export function mapProductDtoArrayToRows(
  dtos: ProductAdministrationDto[],
): ProductRow[] {
  return dtos.map(mapProductDtoToRow);
}

// Using shared formatter from utils for consistency.
